module.exports = __webpack_public_path__ + "static/media/competencia economica.611e92d3.mp4";